// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"Login_formContainer__7W_BJ","primaryButton":"Login_primaryButton__iLrqK","secondaryButton":"Login_secondaryButton__o0ZwZ"};